import React, { useEffect } from "react";
import {
  AppstoreOutlined,
  BarChartOutlined,
  CloudOutlined,
  DatabaseOutlined,
  ShopOutlined,
  TeamOutlined,
  UploadOutlined,
  TranslationOutlined,
  UserOutlined,
  SearchOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Button, Layout, Menu, Tag, theme } from "antd";
import { Outlet, useNavigate } from "react-router-dom";
import logo from "../assets/img/glorri.svg"
const { Header, Content, Footer, Sider } = Layout;

const siderStyle: React.CSSProperties = {
  overflow: "auto",
  height: "100vh",
  position: "fixed",
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  scrollbarWidth: "thin",
  scrollbarGutter: "stable",
};

// const items: MenuProps['items'] = [
//     UserOutlined,
//     //BarChartOutlined,
//     //CloudOutlined,
//     //AppstoreOutlined,
//     //TeamOutlined,
//     //ShopOutlined,
// ].map((icon, index) => ({
//     key: String(index + 1),
//     icon: React.createElement(icon),
//     label: `nav ${index + 1}`,
// }));

const items: any = [
  {
    key: "1",
    icon: React.createElement(SearchOutlined),
    label: `Dashboard`,
    path: "/main/dashboard",
  },
  {
    key: "2",
    icon: React.createElement(UserOutlined),
    label: `Companies`,
    path: "/main/companies",
  },
  {
    key: "3",

    icon: React.createElement(TranslationOutlined),
    label: `Translations`,
    path: "/main/translations",
  },
  {
    key: "4",
    icon: React.createElement(DatabaseOutlined),
    label: `Sources`,
    path: "/main/sources",
  },
  {},
];

const Main: React.FC = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const navigate = useNavigate();

  function handleSelect(param: any) {
    console.log(param.selectedKeys[0]);

    if (items.find((s: any) => s.key === param.selectedKeys[0]))
      navigate(items.find((s: any) => s.key === param.selectedKeys[0]).path);
  }
  const handleLogout =()=>{
    localStorage.removeItem("token")
    navigate("/")
  }

  return (
    <Layout>
      <Header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1100,
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[
            items.find((item: any) =>
              window.location.pathname.includes(item.path)
            )?.key,
          ]}
          items={items}
          onSelect={handleSelect}
          style={{
            flex: 1,
            minWidth: 0,
          }}
        />
       <div>
        <Button onClick={handleLogout} style={{color:"white",padding:"20px"}} color="cyan" type="primary">Logout</Button>
       </div>
      </Header>
      <Content style={{ margin: "24px 16px 0", overflow: "initial" }}>
        <Outlet />
      </Content>
      <Footer style={{ textAlign: "center", marginTop: "150px" }}>
        Ant Design ©{new Date().getFullYear()} Created by Ant UED
      </Footer>
    </Layout>
  );
};

export default Main;
